module.exports = new __parcel__URL__("pin_afaire.d13d0ac6.png").toString();